import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import logo from '../assets/gradoil-logo-horizontal.png';
import SidebarClock from './SidebarClock';

// Цвет фона логотипа.
export const BRAND_GREEN = '#003819';

const useStyles = makeStyles({
  // Блок с логотипом — одного зелёного цвета с самим логотипом, без белого фона;
  // под логотипом белые время и дата.
  brand: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '12px 24px 14px',
    backgroundColor: BRAND_GREEN,
  },
  logo: {
    display: 'block',
    width: 140,
    height: 'auto',
  },
});

// Верх бокового меню: и в рассылках, и в основной системе.
function BrandHeader() {
  const classes = useStyles();
  return (
    <div className={classes.brand}>
      <img className={classes.logo} src={logo} alt="GradOil" />
      <SidebarClock onBrand />
    </div>
  );
}

export default BrandHeader;
